import { ActionModalV2 } from '@newfront-insurance/core-ui/v2';
import { useRef, type ReactNode } from 'react';

export function SettingsConfirmationDialog({
  title,
  description,
  confirmLabel,
  pendingLabel,
  pending,
  disabled = false,
  error,
  onClose,
  onConfirm,
  variant = 'dangerous',
}: {
  title: string;
  description: ReactNode;
  confirmLabel: string;
  pendingLabel: string;
  pending: boolean;
  disabled?: boolean;
  error?: string;
  onClose: () => void;
  onConfirm: () => void;
  variant?: 'confirm' | 'dangerous';
}) {
  const returnFocusTo = useRef(typeof document === 'undefined' ? null : document.activeElement);
  return (
    <ActionModalV2
      isOpen
      variant={variant}
      title={title}
      description={description}
      confirmText={pending ? pendingLabel : confirmLabel}
      isPending={pending}
      isConfirmDisabled={disabled}
      closeOnConfirm={false}
      onClose={onClose}
      onConfirm={onConfirm}
      onCloseAutoFocus={(event) => {
        if (returnFocusTo.current instanceof HTMLElement && returnFocusTo.current.isConnected) {
          event.preventDefault();
          returnFocusTo.current.focus();
        }
      }}
    >
      {error ? (
        <p role="alert" className="text-fire-500 text-sm">
          {error}
        </p>
      ) : null}
    </ActionModalV2>
  );
}
